/* Clair de Truffe — scripts du thème */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withSpaces = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withSpaces + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withSpaces)
      .replace(/\{\{\s*amount\s*\}\}/, parts[0] + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  /* Sélecteur de variantes */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var json = root.querySelector('[data-variants-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var button = root.querySelector('[data-add-button]');
    var buttonLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var badgeEl = root.querySelector('[data-badge]');
    var gallery = document.getElementById(root.dataset.gallery) || root.closest('[data-section]') || document;

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        var legendValue = group.querySelector('[data-selected-value]');
        if (checked && legendValue) legendValue.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });

      // Griser les valeurs qui n'existent pas avec la sélection actuelle
      root.querySelectorAll('[data-option-group]').forEach(function (group, index) {
        group.querySelectorAll('input').forEach(function (input) {
          var test = options.slice();
          test[index] = input.value;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      if (!variant) {
        button.disabled = true;
        buttonLabel.textContent = root.dataset.unavailableText;
        return;
      }
      idInput.value = variant.id;
      button.disabled = !variant.available;
      buttonLabel.textContent = variant.available ? root.dataset.addText : root.dataset.soldOutText;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price); }
      if (badgeEl) { badgeEl.hidden = !onSale; if (onSale) badgeEl.textContent = '−' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + ' %'; }
      if (variant.featured_media) showMedia(gallery, variant.featured_media.id);

      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });
    update();
  });

  /* Galerie produit */
  function showMedia(scope, mediaId) {
    var main = scope.querySelector('[data-main-image], .js-main-image');
    var thumb = scope.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
    if (!main || !thumb) return;
    main.src = thumb.dataset.full;
    main.srcset = '';
    main.alt = thumb.querySelector('img').alt;
    scope.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-gallery]') || thumb.closest('[data-section]') || document, thumb.dataset.mediaId);
  });

  /* Choix d'offre : produit seul ou kit */
  document.querySelectorAll('[data-offer-root]').forEach(function (root) {
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-offer-input]')) return;
      var offer = e.target.value;
      root.querySelectorAll('[data-offer-panel]').forEach(function (p) { p.hidden = p.dataset.offerPanel !== offer; });
      root.querySelectorAll('[data-offer-gallery]').forEach(function (g) { g.hidden = g.dataset.offerGallery !== offer; });
    });
  });

  /* Calculateur de taille */
  document.querySelectorAll('[data-size-calc]').forEach(function (calc) {
    var input = calc.querySelector('input');
    var unit = calc.querySelector('select');
    var result = calc.querySelector('[data-size-result]');
    var scope = calc.closest('[data-size-scope]') || document;
    var rows = scope.querySelectorAll('[data-size-row]');

    function run() {
      var value = parseFloat(String(input.value).replace(',', '.'));
      rows.forEach(function (r) { r.classList.remove('is-match'); });
      if (!value) { result.textContent = ''; return; }
      var cm = unit && unit.value === 'in' ? value * 2.54 : value;
      var best = null, bestDistance = Infinity;
      rows.forEach(function (row) {
        var min = parseFloat(row.dataset.min), max = parseFloat(row.dataset.max);
        if (cm < min || cm > max) return;
        var distance = Math.abs(cm - (min + max) / 2);
        if (distance < bestDistance) { best = row; bestDistance = distance; }
      });
      if (best) {
        best.classList.add('is-match');
        result.textContent = calc.dataset.resultText.replace('[size]', best.dataset.size);
      } else {
        result.textContent = calc.dataset.noResultText;
      }
      updateCta(calc, best && best.dataset.size);
    }
    input.addEventListener('input', run);
    if (unit) unit.addEventListener('change', run);
  });

  /* Bouton « Choisir cette taille » : sélectionne la taille dans le bloc d'achat visible */
  function findSizeInput(match, size) {
    if (!match) return null;
    var wanted = match.toLowerCase();
    var groups = Array.prototype.filter.call(document.querySelectorAll('[data-option-group]'), function (g) {
      return g.offsetParent !== null && g.querySelector('legend').textContent.toLowerCase().indexOf(wanted) !== -1;
    });
    for (var i = 0; i < groups.length; i++) {
      var input = Array.prototype.find.call(groups[i].querySelectorAll('input'), function (el) { return el.value === size; });
      if (input) return input;
    }
    return null;
  }
  function buyBox() {
    return document.querySelector('[data-offer-root]') || document.querySelector('.product');
  }
  function updateCta(calc, size) {
    var cta = calc.querySelector('[data-size-cta]');
    if (!cta) return;
    if (!size) { cta.hidden = true; return; }
    var input = findSizeInput(calc.dataset.optionMatch, size);
    cta.querySelector('[data-size-cta-label]').textContent = input ? 'Choisir la taille ' + size : 'Voir les options';
    cta.hidden = false;
    cta.onclick = function () {
      var target = findSizeInput(calc.dataset.optionMatch, size);
      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var form = target ? target.closest('form') : buyBox();
      if (!form) return;
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var button = form.querySelector('[data-add-button], [data-preview-add]');
      if (button) { button.classList.remove('is-highlight'); void button.offsetWidth; button.classList.add('is-highlight'); }
    };
  }

  /* Points forts : repères sur la photo */
  document.querySelectorAll('[data-hotspots]').forEach(function (root) {
    function activate(n) {
      root.querySelectorAll('[data-hotspot]').forEach(function (h) { h.classList.toggle('is-active', h.dataset.hotspot === n); });
      root.querySelectorAll('[data-hotspot-item]').forEach(function (i) { i.classList.toggle('is-active', i.dataset.hotspotItem === n); });
    }
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-hotspot], [data-hotspot-item]');
      if (el) activate(el.dataset.hotspot || el.dataset.hotspotItem);
    });
    activate('1');
  });

  /* Lien « Trouver sa taille » : ouvre le bon onglet du guide */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-open-size-tab]');
    if (!link) return;
    var guide = document.getElementById('guide-des-tailles');
    if (!guide) return;
    e.preventDefault();
    var tab = guide.querySelector('[data-tab="' + link.dataset.openSizeTab + '"]');
    if (tab) tab.click();
    guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var input = guide.querySelector('[data-tab-panel="' + link.dataset.openSizeTab + '"] input');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 600);
  });

  /* Onglets */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      root.querySelectorAll('[data-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      root.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.hidden = p.dataset.tabPanel !== tab.dataset.tab; });
    });
  });

  /* Barre d'achat collante : visible quand le bloc d'achat est hors écran */
  document.querySelectorAll('[data-sticky-cta]').forEach(function (bar) {
    var box = buyBox();
    if (!box || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var obs = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    obs.observe(box);
    bar.querySelector('[data-sticky-cta-button]').addEventListener('click', function (ev) {
      ev.preventDefault();
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Apparition au défilement */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Tri de collection */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
})();
